import React, { useState } from 'react';
import '../assets/DropDownMenu.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useDispatch } from 'react-redux';
import { fetchDailyOrdersOnlyMonths } from '../redux/slice/dailyOrdersSlice';

const MonthHelpers = ({ month, year, setDate, handleDailyOrdersByMonth }) => {
  const [selectedMonth, setSelectedMonth] = useState(month || new Date().getMonth() + 1);
  const [selectedYear, setSelectedYear] = useState(year || new Date().getFullYear());
  const dispatch = useDispatch()

  const handlePreviousMonth = () => {
    let newMonth = selectedMonth - 1;
    let newYear = selectedYear;

    if (newMonth < 1) {
      newMonth = 12; // Αν ο μήνας πάει πριν τον Ιανουάριο, πηγαίνει στον Δεκέμβριο του προηγούμενου έτους
      newYear -= 1;
    }

    setSelectedMonth(newMonth);
    setSelectedYear(newYear);
    setDate({ month: newMonth, year: newYear });
    dispatch(fetchDailyOrdersOnlyMonths({ 'month': newMonth, 'year': newYear }))
  };

  const handleNextMonth = () => {
    let newMonth = selectedMonth + 1;
    let newYear = selectedYear;

    if (newMonth > 12) {
      newMonth = 1; // Αν ο μήνας πάει μετά τον Δεκέμβριο, πηγαίνει στον Ιανουάριο του επόμενου έτους
      newYear += 1;
    }

    setSelectedMonth(newMonth);
    setSelectedYear(newYear);
    setDate({ month: newMonth, year: newYear });
    dispatch(fetchDailyOrdersOnlyMonths({ 'month': newMonth, 'year': newYear }));
  };

  // Συνάρτηση που επιστρέφει το όνομα του μήνα
  const getMonthName = (monthNumber) => {
    const date = new Date();
    date.setMonth(monthNumber - 1); // -1 γιατί οι μήνες στο JavaScript Date ξεκινούν από 0
    return date.toLocaleString('default', { month: 'long' });
  };

  return (
    <div className="month-container" style={{ display: 'flex', alignItems: 'center' }}>
      <button className="month-item" onClick={handlePreviousMonth}>
        <FontAwesomeIcon icon={faArrowLeft} />
      </button>
      <div className="month-toggle">
        {getMonthName(selectedMonth)}, {selectedYear}
      </div>
      <button className="month-item" onClick={handleNextMonth}>
        <FontAwesomeIcon icon={faArrowRight} />
      </button>
    </div>
  );
};

export default MonthHelpers;
